const getParamsFromUrl = (): Record<string, string | undefined> => {
  const params = new URLSearchParams(decodeURIComponent(window.location.search))
  const paramObj = {}
  for (const value of params.keys()) {
    paramObj[value] = params.get(value)
  }
  return paramObj
}

export default getParamsFromUrl
